if (window.matchMedia('(min-width: 993px)').matches) {
  (async () => {
      const { Core } = await importModule('Core');
      const { Swiper } = await importModule('Swiper');
  
      const ATTR_INITIAL_POSITION = 'initial-image-position';
  
      customElements.define('product-gallery', class extends Core {
          elements = {
              swiper: '[data-swiper]',
              pagination: '[data-pagination]'
          }
  
          subscriptions = {
              'variant:change': '_onVariantChange'
          }
  
          render() {
              this._initDesktopSwiper();
              this.subscribe('variant:change');
          }
  
          _initDesktopSwiper() {
              this._destroySwiper();
              this.swiper = new Swiper(this.$swiper, {
                  autoHeight: true,
                  pagination: {
                      el: this.$pagination,
                      type: 'bullets'
                  },
                  breakpoints: {
                      992: {
                          allowTouchMove: false
                      }
                  }
              });
              if (this.initialPosition) {
                  this.swiper.slideTo(+this.initialPosition - 1);
              }
          }
        
          _destroySwiper() {
              if (this.swiper) {
                  this.swiper.destroy(true, true);
                  this.swiper = null;
              }
          }
  
          _onVariantChange({ variantImagePosition }) {
              if (variantImagePosition && this.swiper) {
                  this.swiper.slideToLoop(variantImagePosition - 1);
              }
          }
  
          get slider() {
              return this.swiper;
          }
  
          get initialPosition() {
              return this.getAttribute(ATTR_INITIAL_POSITION);
          }
      });
  })();
}
if (window.matchMedia('(max-width: 992px)').matches) {
  // (async () => {
  //     const { Core } = await importModule('Core');
  //     const { Swiper } = await importModule('Swiper');
  
  //     const CN_NAV_DISABLED = '!disabled';
  
  //     customElements.define('product-gallery', class extends Core {
  //         elements = {
  //             swiper: '[data-swiper]',
  //             next: '[data-next]',
  //             prev: '[data-prev]',
  //             pagination: '[data-pagination]'
  //         }
  
  //         render() {
  //             this._initMobileSwiper();
  //         }
  
  //         _initMobileSwiper() {
  //             this._destroySwiper(); 
  //             this.swiper = new Swiper(this.$swiper, {
  //                 autoHeight: true,
  //                 loop: true,
  //                 slidesPerView: 1,
  //                 spaceBetween: 0,
  //                 pagination: {
  //                     el: this.$pagination,
  //                     type: 'bullets',
  //                     clickable: true
  //                 },
  //                 navigation: {
  //                     nextEl: this.$next,
  //                     prevEl: this.$prev,
  //                     disabledClass: CN_NAV_DISABLED
  //                 }
  //             });
  //             this.swiper.slideToLoop(0);
  //         }
  
  //         _destroySwiper() {
  //             if (this.swiper) {
  //                 this.swiper.slideTo(0, 0);
  //                 this.swiper.destroy(true, true);
  //                 this.swiper = null;
  //             }
  //         }
  //     });
  // })();
  (async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]'
        }

        subscriptions = {
            'variant:change': '_onVariantChange'
        }

        render() {
            this._initDesktopSwiper();
            this.subscribe('variant:change');
        }

        _initDesktopSwiper() {
            this._destroySwiper();
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                loop: true,  // Enable looping
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                breakpoints: {
                    992: {
                        allowTouchMove: false
                    }
                }
            });

            // Always move to the first slide on load
            this.swiper.on('init', () => {
                this.swiper.slideToLoop(0); 
            });

            this.swiper.init(); // Ensure Swiper initializes
        }
      
        _destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        _onVariantChange({ variantImagePosition }) {
            if (variantImagePosition && this.swiper) {
                this.swiper.slideToLoop(variantImagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }
    });
  })();



}

